/**
 * @module
 * @format
 */

/**
 * @import {AmateurData} from "../amateurPool/model/amateur-data.js";
 */

import {fskTrans} from '../userPool/0fsk.js';

class AmateurInfo {
  #data;

  /**
   * @param {AmateurData} data
   */
  constructor(data) {
    this.#data = data;
  }

  get moreAbout() {
    const data = this.#data;
    const aboutMe = fskTrans(data.about_me);
    const fantasies = fskTrans(data.fantasies);
    const othersAboutMe = fskTrans(data.others_about_me);

    if (!aboutMe && !fantasies && !othersAboutMe) {
      return null;
    }

    return {aboutMe, fantasies, othersAboutMe};
  }
}

export {AmateurInfo};
